"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * State of button on ribbon
 */
var RibbonButtonState;
(function (RibbonButtonState) {
    /**
     * A normal button
     */
    RibbonButtonState[RibbonButtonState["Normal"] = 0] = "Normal";
    /**
     * A button in checked state
     */
    RibbonButtonState[RibbonButtonState["Checked"] = 1] = "Checked";
    /**
     * A disabled button
     */
    RibbonButtonState[RibbonButtonState["Disabled"] = 2] = "Disabled";
})(RibbonButtonState = exports.RibbonButtonState || (exports.RibbonButtonState = {}));
//# sourceMappingURL=RibbonButton.js.map